module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/outdent.fd588b14.svg";